import H from 'constants/httpMethod.const';
import fromDtoToSalonCore from 'dto/salon/fromDtoToSalonCore.dto';
import fromSalonCoreToDto from 'dto/salon/fromSalonCoreToDto.dto';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';

// TODO: add ibeSomethingSearch, abeSomethingCreate, ibeSomethingUpdatem abeSomethingReplace, etc.

export const abeSalonCoreUpdate = actionEndpointBe('abeSalonCoreUpdate', H.put, 'salon/:salonId/', (options, extra) => ({
  ...options,
  fromDto: fromDtoToSalonCore,
  toDto: fromSalonCoreToDto,
  data: extra?.data,
}));

export const ibeSalonCoreUpdate = actionEndpointBe('ibeSalonCoreUpdate', H.put, 'salon/:salonId/', (options, extra) => ({
  ...options,
  inert: true,
  fromDto: fromDtoToSalonCore,
  toDto: fromSalonCoreToDto,
  data: extra?.data,
}));
